/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "../Lang"
import BaseCom from "../BaseCom";
import Card from "../Card";
import LoadingAlert from "../LoadingAlert";
import Alert from "../Alert";

export default class PanelSelect extends BaseCom {
    async componentDidMount() {
        await this.fillListAsync('/api/panel/list', 'list');
        this.setState({ loaded: true });
    }

    change = () => {
        this.props.onChange?.();
    }

    togglePanel = (panel) => {
        var i = this.props.item.panels.findIndex(t => t.id === panel.id);
        if (i === -1)
            this.props.item.panels.push(panel);
        else
            this.props.item.panels.splice(i, 1);
        this.change();
    }

    getSelectedPanel = (id) => {
        return this.props.item.panels.find(t => t.id === id);
    }

    filterPanels = () => {
        return this.state.list?.filter(a => !this.state.panelSearch || a.name.toLowerCase().trim().indexOf(this.state.panelSearch.toLowerCase().trim()) >= 0);
    }

    render() {
        if (!this.state.loaded)
            <LoadingAlert />
        return <Card title="Panels">
            {!this.props.readOnly && <>
                <input type="text" className="form-control mb-1" placeholder="Search targets..." onChange={(e) => this.setState({ panelSearch: e.target.value })} />
                <div className="overflow-list no-select">
                    <ul className="list-group">
                        {this.filterPanels()?.map(i => <li role="button" key={i.id} onClick={() => this.togglePanel(i)} className={'list-group-item d-flex' + (this.getSelectedPanel(i.id) ? ' active' : '')}>
                            <input type="checkbox" className="d-block" checked={this.getSelectedPanel(i.id)} />
                            <div className="ms-2 flex-fill">
                                {i.name}
                            </div>
                            <div className="ms-2">
                                {i.code}
                            </div>
                        </li>)}
                    </ul>
                </div>
            </>}
            {!this.props.readOnly && this.props.item?.panels?.length > 0 && <div className="mt-2">
                <div className="mb-1"><L>Selected Panels:</L></div>
                {this.props.item?.panels?.map(i => <span key={i.id} className="badge bg-primary me-1">{i.name} ({i.code}) {!this.props.readOnly && <button type="button" className="btn-close" onClick={() => this.togglePanel(i)}></button>}</span>)}
            </div>}
            {this.props.readOnly && <div className="mt-2">
                <ul className="list-group">
                    {this.props.item?.panels?.map((i, idx) => <div key={idx} className="list-group-item">{i.name} ({i.code})</div>)}
                </ul>
                {this.props.item?.panels?.length === 0 && <Alert type="warning"><L>No panels selected.</L></Alert>}
            </div>}
        </Card>;
    }
}